// extracted by mini-css-extract-plugin
export var disabled = "_6-a";
export var hierarchyLinkGray = "_6-4";
export var hierarchyLinkUnderline = "_6-3";
export var hierarchyPrimary = "_6-0";
export var hierarchySecondary = "_6-1";
export var hierarchyTertiary = "_6-2";
export var pressed = "_6-6";
export var themeAction = "_6-5";
export var themeDestructive = "_6-8";
export var themeNormal = "_6-7";
export var themeSuccess = "_6-9";